import { Action, createReducer, on } from '@ngrx/store';
import { loadSelectedEmployees } from '../actions/selected-employee.actions';
import { ISearchEmployeeResponse } from '../models/search-employees.model';

export const selectedEmployeeFeatureKey = 'selectedEmployee';

export interface SelectedEmployeeState {
  loadSelectedEmployee: any;
}

export const initialState: SelectedEmployeeState = {
  loadSelectedEmployee: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadSelectedEmployees, (state, action) => ({
    ...state,
    loadSelectedEmployee: action.selected
  }))
);

export const getSelectedEmployee = (state: SelectedEmployeeState) => state.loadSelectedEmployee;

export const getSelectedEmployeeUserProfileId = (state: SelectedEmployeeState) => {
  let userProfileId: string;
  if (state.loadSelectedEmployee !== undefined) {
    userProfileId = state.loadSelectedEmployee.customerId;
  }
  return userProfileId;
};
